import { useEffect, useState,useContext } from "react";
import $ from "jquery";
import {Card,Form, Accordion} from 'react-bootstrap';
import {
    useNavigate
} from "react-router-dom";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import UserContext from "../../contexts/UserContext";

ChartJS.register(ArcElement, Tooltip, Legend);

const FeedbackReport = () => {

const navigate = useNavigate();

const {user,setUser} = useContext(UserContext);
const [feedbackDates,setFeedbackDates] = useState([]);   
const [quantityFeedback,setQuantityFeedback] = useState([]); 
const [qualityFeedback,setQualityFeedback] = useState([]); 
const [finalPieDataQuality,setFinalPieDataQuality] = useState([]);
const [finalPieDataQuantity,setFinalPieDataQuantity] = useState([]);

async function getData(userId){
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
        if(response && response.user){
           setUser(response.user);
        }else{
          setUser(null)
          navigate("/login",{state: { message: response.message }})
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
  })
  }
  
useEffect(()=>{
    try{
    if(!user && localStorage.getItem('userSession')){
      getData(JSON.parse(localStorage.getItem('userSession')))
    }else{
      if(!user){
        navigate("/login")
      }
    }
  }catch(e){
    if(!user){
      navigate("/login")
    }
  }
  },[])

const getDataTillNow = async () => {
    await $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getDataForFeedback",
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : function(response){
          if(response){
             setFeedbackDates(response.dates);
          }else{
            navigate("/login",{state:{message:"Please Login !"}})
          }
  
        },
        error: function(err){
            console.log("error")
            console.log(err)
            navigate("/login",{state:{message:"Something went wrong !"}})
        }
    })
}

const getMenuForDate = async (e) => {
    await $.ajax({
        type:"POST",
        url:process.env.REACT_APP_API_URL+"/getFeedbackReport",
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
          data:{date:new Date(e.target.value).toDateString()},
         success : function(response){
          if(response){
            if(response.quantityFeedback.length>0){
                setQuantityFeedback(response.quantityFeedback)
            }
            if(response.qualityFeedback.length>0){
                setQualityFeedback(response.qualityFeedback)
            }
            separateForDisplay(e.target.value,response.qualityFeedback,response.quantityFeedback);
          }else{
            navigate("/login",{state:{message:"Please Login !"}})
          }
  
        },
        error: function(err){
            console.log("error")
            console.log(err)
            navigate("/login",{state:{message:"Something went wrong !"}})
        }
    })
}

const separateForDisplay = (CurfeedbackDate,qualityFeedback,quantityFeedback) => {
    let qualobj = {};
    let quanobj = {};
    qualityFeedback.map((currFeedback) => {
        for(let i=0;i<currFeedback.items.length;i++){
            if(qualobj[currFeedback.items[i].name]){
                qualobj[currFeedback.items[i].name].push(currFeedback.items[i].feedback)
            }else{
                qualobj[currFeedback.items[i].name]=[currFeedback.items[i].feedback];
            }
        }
    })

    quantityFeedback.map((currFeedback) => {
        for(let i=0;i<currFeedback.items.length;i++){
            if(quanobj[currFeedback.items[i].name]){
                quanobj[currFeedback.items[i].name].push(currFeedback.items[i].feedback)
            }else{
                quanobj[currFeedback.items[i].name]=[currFeedback.items[i].feedback];
            }
        }
    })
    setDataForPie(qualobj,quanobj);
}

function setDataForPie(qualobj,quanobj){
    let obj=[];
    for (const [key, value] of Object.entries(qualobj) ){
            let predata = {
                labels: ['Needs Improvement', 'Eatable', 'Tasty'],
                datasets: [{
                    label: 'Count',
                    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
                    hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
                }]
            };
            let arrdata = [];
            arrdata.push(Number(value.filter(val => val==="needsImprovement").length))
            arrdata.push(Number(value.filter(val => val==="eatable").length))
            arrdata.push(Number(value.filter(val => val==="tasty").length))
        // } 
        predata.datasets[0].data = arrdata;
        obj.push({[key]:predata});
    }
    setFinalPieDataQuality(obj);
    obj=[];
    for (const [key, value] of Object.entries(quanobj) ){
            let predata = {
                labels: ['Less', 'Adequate', 'More'],
                datasets: [{
                    label: 'Count',
                    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
                    hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
                }]
            };
            let arrdata = [];
            arrdata.push(Number(value.filter(val => val==="less").length))
            arrdata.push(Number(value.filter(val => val==="adequate").length))
            arrdata.push(Number(value.filter(val => val==="more").length))
        // } 
        predata.datasets[0].data = arrdata;
        obj.push({[key]:predata});
    }
    setFinalPieDataQuantity(obj);
}

const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true, // Display the legend
      },
};

useEffect(() => {
    getDataTillNow();
},[])

const PieCard = ({data}) => {
    const design = (
        <>
            {
            data.map((pieData) => {
                    if(pieData){
                        return <>
                        <div style={{width:'100%'}}>
                            <h6>{Object.keys(pieData)[0]}</h6>
                            <div style={{width:'100%'}} >
                            <Pie data={Object.values(pieData)[0]} options={options}/>
                            </div>
                        </div>    
                        </>
                    }
                })
            } 
        </>
    )
    return design
}

const Comments = () => {
    const design = (
        <>
        <Accordion  className="commentsCard">
        <Accordion.Item eventKey="0">
            <Accordion.Header>Written Feedback from Mumineen</Accordion.Header>
            <Accordion.Body>
            {
                qualityFeedback.map((currFeedback,i) => {
                    return currFeedback.comments && currFeedback.comments.length>0?
                    <>
                        <Card>
                        <Card.Body>
                            <blockquote className="blockquote mb-0">
                            <p>
                                {' '}
                                {currFeedback.comments}.{' '}
                            </p>
                            <footer className="blockquote-footer">
                                <cite title="Source Title">{currFeedback.userInfo.name.toLowerCase()}</cite>
                            </footer>
                            </blockquote>
                        </Card.Body>
                        </Card>
                    </>
                    :
                    i<=0?<p style={{padding:'5px',color:'white',textAlign:'center'}}>No data</p>:null
                })
            }
            </Accordion.Body>
        </Accordion.Item>
        </Accordion>
        </>
    )
    return design;
}

    const design = (
        <>
        <Form.Select style={{width:'90%'}} className="d-flex m-3 mt-4" aria-label="Select Date" onChange={getMenuForDate}>
            <option>Select From Last 7 Days For Feedback</option>
            {
                feedbackDates.length>0?
                feedbackDates.map((feedbackDate) => {
                    return <option value={feedbackDate}>{feedbackDate}</option>
                }):null
            }
        </Form.Select>
        <Form.Group  style={{width:'90%'}} className="d-flex m-3 mt-4">
        <Form.Label>Select Custom Date</Form.Label>
        <Form.Control onChange={getMenuForDate} type="date" placeholder="Select custom Date" />
        </Form.Group>
            {
                finalPieDataQuality.length>0?
                <>
                <div className="d-flex flex-wrap pieCards">
                    <h5 style={{textAlign:"center",width:'100%'}}>Quality Feedback</h5><br/>
                    <p style={{textAlign:'center',width:'100%'}}>Total response received: {qualityFeedback.length}</p>
                    <PieCard data={finalPieDataQuality}/>
                </div>
                <Comments />
                </>
                :null
            }
            {
                finalPieDataQuantity.length>0?
                <>
                <div className="d-flex flex-wrap mt-5 pieCards">
                    <h5 style={{textAlign:"center",width:'100%'}}>Quantity Feedback</h5><br/>
                    <p style={{textAlign:'center',width:'100%'}}>Total response received: {quantityFeedback.length}</p>
                    <PieCard data={finalPieDataQuantity}/>
                </div>
                </>
                :null
            }
        </>
    )
    return design;
}

export default FeedbackReport;